import React from 'react';
import { GlobalStore } from './stores/global.store';

export const globalStoreInstance = new GlobalStore();
export const StoreContext = React.createContext(globalStoreInstance);
export const useStore = () => React.useContext(StoreContext);
